import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import motion from "@/lib/lazy-motion-tags";
import { Button } from "@/components/ui/button";
import IconLoader from "@/components/IconLoader";
import { Helmet } from "react-helmet";
import { trackPhoneCall } from "@/lib/analytics";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <>
      <Helmet>
        <title>الصفحة غير موجودة - New Business</title>
        <meta name="description" content="الصفحة التي تبحث عنها غير موجودة. عُد إلى الصفحة الرئيسية لشركة New Business" />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background via-muted/30 to-background">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center max-w-2xl mx-auto"
          >
            {/* 404 Number */}
            <motion.div
              initial={{ scale: 0.5 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="text-8xl md:text-9xl font-bold text-gradient mb-8"
            >
              404
            </motion.div>

            {/* Title */}
            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="text-4xl md:text-5xl font-bold mb-6"
            >
              الصفحة غير موجودة
            </motion.h1>

            {/* Description */}
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.6 }}
              className="text-xl text-muted-foreground mb-12 leading-relaxed"
            >
              عذراً، الصفحة التي تبحث عنها غير موجودة أو تم نقلها. يرجى العودة إلى الصفحة الرئيسية أو تصفح منتجاتنا.
            </motion.p>

            {/* Buttons */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.8 }}
              className="flex flex-col sm:flex-row gap-4 justify-center items-center"
            >
                    <Button asChild size="lg" className="bg-gradient-primary text-primary-foreground font-bold text-lg px-8 py-6 shadow-glow hover:shadow-elegant transition-all">
                <Link to="/">
                  <IconLoader name="Home" className="ml-2 h-5 w-5" />
                  العودة للرئيسية
                </Link>
              </Button>
              <Button asChild size="lg" variant="outline" className="border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground font-bold text-lg px-8 py-6">
                <Link to="/products">
                  تصفح المنتجات
                  <IconLoader name="ArrowLeft" className="mr-2 h-5 w-5" />
                </Link>
              </Button>
            </motion.div>

            {/* Additional Help */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 1 }}
              className="mt-16 text-sm text-muted-foreground"
            >
              <p>إذا كنت تواجه مشكلة، يمكنك التواصل معنا مباشرة</p>
              <a
                href="tel:+966552351116"
                onClick={() => trackPhoneCall("not_found")}
                className="text-primary hover:underline font-medium"
              >
                +966 55 235 1116
              </a>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default NotFound;
